export default "__VITE_ASSET__f77c2631__"